import { loadScript, loadCSS, Listeners, onSortGoTo } from './utils.js';
import KeenSlider, { sliderDots, sliderArrows, upsellArrow, sliderAutoPlay } from './keen-slider.js';
import Bugsnag from '@bugsnag/js';
import { CosTooltip } from './cos-tooltip.js'; 

window.themeRoleMain && Bugsnag.start({ apiKey: '058ec54126aa770dce303b24fe7d06dd' });

function removeElement(element) {
  if (element) element.remove();
}

function createDiv(className) {
  const div = document.createElement('div');
  const classNames = className.split(' ');
  classNames.forEach((name) => div.classList.add(name));
  return div;
}

window.Listeners = Listeners;

class CosPopup extends HTMLElement {
  // filters
  // sort

  constructor() {
    super();
    this.show = false;
    this.hideListeners = new Listeners();
    this.extraClasses = [];
    this.accordionIndex = [];
    this.accordionOpenId = null;
    this.settings = JSON.parse(this.getAttribute('data-settings')) || {};
  }

  connectedCallback() { 
    const triggers = document.querySelectorAll('[toggle-popup="' + this.id + '"]');
    this.popupWrapper = this.querySelector('.popup-wrapper');
    this.overlay = this.querySelector('.overlay');

    triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        if (this.activeTrigger === trigger && trigger.hasAttribute('no-disable')) {
          this.hidePopup(e, false, false);
          e.preventDefault();
          return;
        }
        document.dispatchEvent(new CustomEvent('cos.popups.close', {
          detail: { id: this.id }
        }));
        this.activeTrigger = trigger;
        this.isDropdown = trigger.hasAttribute('dropdown');

        if (this.isDropdown) {
          this.extraClassesAdd('no-animations');
        }

        // if (trigger.getAttribute('popup-show-only')) {
        //   const showOnly = trigger.getAttribute('popup-show-only');
        //   const elementsToShow = this.querySelectorAll(showOnly);

        //   elementsToShow.forEach(element => {
        //     element.parentElement.classList.add('show-only__parent');
        //     element.classList.add('show-only');
        //   });
        // }

        if (trigger.getAttribute('popup-custom-event')) {
          const customEvent = trigger.getAttribute('popup-custom-event');
          document.dispatchEvent(new CustomEvent(customEvent));
        }

        if (trigger.getAttribute('accordion-index')) {
          this.accordionIndex[0] = parseInt(trigger.getAttribute('accordion-index'));
        }

        if (trigger.getAttribute('accordion-open-id')) {
          this.accordionOpenId = trigger.getAttribute('accordion-open-id');
        }

        // if (this.id === 'CartSide' && window.matchMedia("(max-width: 989px)").matches) {
        //   // window.location.href = `${ window.location.origin }/cart`;
        // } else {
        // }

        e.preventDefault();
        this.togglePopup(e);
      });
    });

    // document.addEventListener('cos.popup.open', (e) => {
    //   if (!e.detail) return;
    //   if (e.detail.id !== this.id) return;
    //   document.dispatchEvent(new CustomEvent('cos.popups.close'));
    //   this.togglePopup(e);
    // });

    document.addEventListener('cos.popup.open', (e) => {
      if (!e.detail) return;
      if (e.detail.id !== this.id) return;

      document.dispatchEvent(new CustomEvent('cos.popups.close', {
        detail: { id: this.id }
      }));
      this.togglePopup(e);
    });
  }

  destroy() {
    this.hideListeners.removeAll();
    // this.cartTopListeners.removeAll();

    if (this.isDropdown) {
      this.removeAttribute('style');
      if (this.overlay) this.overlay.removeAttribute('style');
      if (this.popupWrapper) this.popupWrapper.removeAttribute('style');
      
      this.isDropdown = false;
    }

    this.removeEventListener('cos.popup.reinitExtras', (e) => this.reinitAccordion());

    this.accordionIndex = [];
    this.activeTrigger = null;
    
    this.timeOutClose(false);
  }

  togglePopup(e, persist) { 
    // e.preventDefault();
    if (e) e.stopImmediatePropagation();

    this.show = !this.show;
    
    if (this.show) {
      this.dispatchEvent(new CustomEvent('cos.popup.isOpening'));
      // this.prepareAnimations();
      this.handleInsertOnOpen();
      this.handleInserts();
      this.initExtras();

      (this.accordionOpenId) ? this.openAccordionId() : this.openAccordionIndex();
      
      this.classList.add('is-open');
      document.body.classList.add('popup-active');
      this.inert = false;
      document.dispatchEvent(new CustomEvent('visely.search.filters.close'));

      this.hideOnScroll = this.hideOnScroll || this.getAttribute('hide-on-scroll');
      if (this.hideOnScroll || this.isDropdown) {
        this.extraClassesAdd('hide-on-scroll');
        this.hideListeners.add(document, 'scroll', () => this.timeOutClose());
        this.hideListeners.add(this, 'mouseover', () => this.timeOutClose(false));
        this.hideListeners.add(this, 'mouseout', () => this.timeOutClose()); 
      } else {
        document.body.classList.add('disable-scroll');
      }

      if (persist) return this.dispatchEvent(new CustomEvent('cos.popup.isOpened'));

      this.hideListeners.add(document, 'cos.popups.close', (e) => {
        console.log('cos.popups.close', e.detail);
        // if (e.detail && e.detail.id === this.id) return;
        this.hidePopup(e, false, e.detail && e.detail.id === this.id);
      });

      this.hideListeners.add(document, 'keydown', ({key}) => key === 'Escape' && this.hidePopup());
      this.hideListeners.add(document, 'click', (e) => this.onClickOutside(e));
      this.hideListeners.add(window, 'hashchange', (e) =>  this.hidePopup());

      const closeBtn = this.querySelectorAll('[close-popup]');
      closeBtn.forEach(btn => this.hideListeners.add(btn, 'click', (e) => this.hidePopup(e, true)));

      // if (this.lastElementChild) this.lastElementChild.focus();

      if (this.activeTrigger) {
        this.activeTrigger.classList.add('active');
        // if (!this.noDisable) this.activeTrigger.setAttribute('disabled', 'true');

        if (this.isDropdown) {
          this.extraClassesAdd('is-dropdown');
          this.cancelAnimations();
          
          const activeTriggerDetails = this.activeTrigger.getBoundingClientRect();
          const activeTriggerBottom = activeTriggerDetails.bottom;          
          const windowHeight = window.innerHeight;

          this.style.top = activeTriggerBottom + 'px';
          
          const untilBottom = windowHeight - activeTriggerBottom;
          if (this.popupWrapper) this.popupWrapper.style.maxHeight = (untilBottom < 500) ? untilBottom + 'px' : '500px';

          // setTimeout(() => {
            const thisDetails = this.getBoundingClientRect();

            const middleOfTrigger = activeTriggerDetails.left + activeTriggerDetails.width / 2;
            const tooRight = middleOfTrigger + (thisDetails.width / 2) + 20 > window.innerWidth;

            this.style.left = tooRight ? 'auto' : middleOfTrigger - (thisDetails.width / 2) + 'px';              
            this.style.right = tooRight ? '20px' : 'auto';  
          // }, 500);
                    
          this.hideListeners.add(window, 'scroll', (e) =>  {
            const activeTriggerBottom = this.activeTrigger.getBoundingClientRect().bottom;
            const untilBottom = windowHeight - activeTriggerBottom;

            this.style.top = activeTriggerBottom + 'px';
            if (this.popupWrapper) this.popupWrapper.style.maxHeight = (untilBottom < 500) ? untilBottom + 'px' : '500px';
          });
        }
      }

      // Potentially add a google event here
      // if (typeof ga !== "undefined") ga("send", "event", {eventCategory: "Comanda acum", eventAction: "Click", eventLabel: "Deschide optiuni"});

      // this.playAnimations();
      this.dispatchEvent(new CustomEvent('cos.popup.isOpened'));
      // this.updateSlider();

      setTimeout(() => {
        this.focusFirstInput();
      }, 500);
    } else {
      this.hidePopup();
    }
  }

  // updateSlider(instant) {
    // const cosSlider = this.querySelector('cos-slider');   
    // if (!cosSlider) return;

    // setTimeout(() => {
    //   cosSlider.updateSlider();
    // }, instant ? '0' : '10');
  // }

  timeOutClose(runAgain = true) {
    clearTimeout(this.timeOut);
    if (runAgain) this.timeOut = setTimeout(() => this.hidePopup(), 1000);
  }
  
  hidePopup(e, preventDefault, quickClose) {
    if (preventDefault) e.preventDefault();
    this.dispatchEvent(new CustomEvent('cos.popup.isHiding'));

    if (this.activeTrigger) {
      this.activeTrigger.classList.remove('active');
      this.activeTrigger.removeAttribute('disabled');
    }

    // this.classList.remove('is-closing');
    this.classList.remove('is-open');

    document.body.classList.remove('popup-active');
    document.body.classList.remove('disable-scroll');  
    this.inert = true;

    this.hideOnScroll = false;
    this.show = false;

    if (quickClose) {
      this.delayedCloseFunctions();
    } else {
      setTimeout(() => {
        this.delayedCloseFunctions();
      }, 500);
    }
    
    this.handleInserts();
    this.destroy();
    this.dispatchEvent(new CustomEvent('cos.popup.isHidden'));
  }

  delayedCloseFunctions() {
    this.handleInsertOnOpen();
    this.clearExtraClasses();
    this.clearShowOnly();
  }

  cancelAnimations() {
    this.style.animation = 'none';
    if (this.overlay) this.overlay.style.animation = 'none';
    if (this.popupWrapper) this.popupWrapper.style.animation = 'none';
  }

  focusFirstInput() {
    const firstInput = this.querySelector('input:not([type="hidden"]):not([disabled])');
    if (!firstInput) return;
    
    firstInput.focus();
  }

  // prepareAnimations() {
  //   if (!this.popupWrapper) return;

  //   const popupWrapperKeyframes = new KeyframeEffect(this.popupWrapper, 
  //     [
  //       { transform: 'translateX(100%)', opacity: 0.25 }, 
  //       { transform: 'translateX(0%)' }
  //     ], 
  //     { duration: 300, easing: 'ease' }
  //   );
  //   this.popupWrapperAnimation = new Animation(popupWrapperKeyframes, document.timeline);


  //   if (!this.overlay) return;

  //   const overlayKeyframes = new KeyframeEffect(this.overlay, 
  //     [
  //       { opacity: 0 }, 
  //       { opacity: 1 }
  //     ], 
  //     { duration: 300, easing: 'ease' }
  //   );
  //   this.overlayAnimation = new Animation(overlayKeyframes, document.timeline);
  // }

  // playAnimations() {
  //   if (this.popupWrapperAnimation) this.popupWrapperAnimation.play();
  //   if (this.overlayAnimation) this.overlayAnimation.play();
  // }

  // reverseAnimations() {
  //   if (this.popupWrapperAnimation) this.popupWrapperAnimation.reverse().then(() => {
  //     this.classList.remove('is-open');
  //   });
  //   if (this.overlayAnimation) this.overlayAnimation.reverse().then(() => {
  //     this.classList.remove('is-open');
  //   });
  // }

  extraClassesAdd(className) {
    this.extraClasses.push(className);
    this.classList.add(className);
  }

  clearExtraClasses() {
    this.extraClasses.forEach(className => this.classList.remove(className));
    this.extraClasses = [];
  }

  clearShowOnly() {
    const showOnly = this.querySelectorAll('.show-only');
    if (!showOnly) return;

    showOnly.forEach(show => {
      show.classList.remove('show-only');
      show.parentElement.classList.remove('show-only__parent');
    });
  }
  
  onClickOutside(e) {    
    if (!this.contains(e.target) && this.show) {
      const pottentialTrigger = e.target.closest('[toggle-popup]');
      if (pottentialTrigger && pottentialTrigger.getAttribute('toggle-popup') === this.id) return;
      
      const pottentialFilterList = e.target.closest('cos-fetch-link');
      if (pottentialFilterList) return;        
      
      this.hidePopup(e);
    }
  }

  removeOnScroll() {
    this.hideOnScroll = false;
    this.hideListeners.remove(document, 'scroll');
    document.body.classList.add('disable-scroll');
  }

  openAccordionIndex() {
    if (!this.accordion || true) return;
    console.log('openAccordionIndex', this.accordionIndex[0]);

    if (this.accordionIndex.length) {
      this.accordion.update();
      this.accordion.open(this.accordionIndex[0]);

      // this.accordion.destroy();
      // this.initAccordion();
    } else {
      this.accordion.closeAll();
    }
  }

  openAccordionId() {
    if (!this.accordion) return;
    console.log('openAccordionId', this.accordionOpenId);
    
    if (this.accordionOpenId) {
      this.accordion.update(this.accordionOpenId);
      this.accordion.openId(this.accordionOpenId, false);
    } else {
      this.accordion.closeAll();
    }
  }

  reinitAccordion(e) {
    if (!e.detail) return;
    
    this.accordionIndex[0] = (typeof e.detail.accordionIndex === 'number') ? e.detail.accordionIndex : this.accordionIndex[0];
    this.accordionOpenId = e.detail.afterUpdateId || this.accordionOpenId;
    console.log('reinitAccordion', this.accordionIndex[0], this.accordionOpenId, e.detail);
    (e.detail.afterUpdateId) ? this.openAccordionId() : this.openAccordionIndex();

    // this.accordion.destroy();
    // this.initAccordion();
  }

  initExtras(overpass) {
    // check if already initialized
    if (this.extrasInitialised && !overpass) return;
    
    // Add here init code for custom features when needed
    this.dispatchEvent(new CustomEvent('cos.popup.initExtras'));
    this.initAccordion();
    this.insertScripts();
    this.loadModules();
    this.insertCSS();
    // this.initSizeGuide();
    // this.initViselyRecommendations();
    // this.initSearch();

    this.extrasInitialised = true;
  }

  insertScripts() {
    if (!this.settings.load_scripts) return;
    
    this.settings.load_scripts.forEach((script) => {
      loadScript(script, () => {
        console.log('Loaded ' + script);
      });
    });
  }

  loadModules() {
    if (!this.settings.load_modules) return;

    this.settings.load_modules.forEach((module) => {
      import(module).then(() => {
        console.log('Loaded ' + module);
        document.dispatchEvent(new CustomEvent('popup.module.loaded', { detail: 
          { module } 
        }));
      });
    });
  }

  insertCSS() {
    if (!this.settings.load_css) return;
    
    this.settings.load_css.forEach((css) => {
      loadCSS(css, () => {
        console.log('Loaded ' + css);
      });
    });
  }

  initAccordion() {
    // only supports ONE accordion per popup for now
    const accordion = this.querySelector('[popup-accordion]');
    if (!accordion) return;
    
    import(window.modules.accordion)
      .then(({ default: Accordion }) => {
        this.accordion = new Accordion(accordion, {
          // openOnInit: this.accordionIndex,
          openOnInitId: this.accordionOpenId,
          onlyChildNodes: !accordion.getAttribute('only-child-nodes') === 'false'
        });
      })
      .catch((e) => {
        Bugsnag.notify(e);
        console.warn(e);
      });

    this.addEventListener('cos.popup.reinitExtras', (e) => this.reinitAccordion(e));
  }

  handleInsertOnOpen() {
    if (!this.settings.insertOnOpen) return;

    this.insertOnOpen = this.insertOnOpen || document.querySelector(this.settings.insertOnOpen);
    if (!this.insertOnOpen) return;

    this.insertOnOpenParent = this.insertOnOpenParent || this.insertOnOpen.parentElement;
    if (!this.insertOnOpenParent) return;

    this.placeToInsert = this.placeToInsert || this.querySelector(this.settings.placeToInsert || '[insert-on-open]');
    if (!this.placeToInsert) return;

    if (this.show) {
      const heightToKeep = this.insertOnOpenParent.offsetHeight;
      this.insertOnOpenParent.style.minHeight = heightToKeep + 'px';
      this.placeToInsert.appendChild(this.insertOnOpen);
    } else {
      this.insertOnOpenParent.appendChild(this.insertOnOpen);
      this.insertOnOpenParent.style.minHeight = '';
    }
  }

  handleInserts() {
    if (!this.settings.inserts) return;

    this.inserts = this.inserts || [];

    // this.settings.inserts.forEach((insert, index) => {
    //   const insertElement = document.querySelector(insert.selector);
    //   if (!insertElement) return;

    //   const placeToInsert = this.querySelector(`[insert=${insert.insert}]`);
    //   if (!placeToInsert) return;

    //   if (this.show) {
    //     // const heightToKeep = this.inserts[index].insertElementParent.offsetHeight;
    //     // this.inserts[index].insertElementParent.style.minHeight = heightToKeep + 'px';
    //     const clone = insertElement.cloneNode(true);
    //     clone.classList.add('clone');
    //     placeToInsert.appendChild(clone);

    //     if (index === this.settings.inserts.length - 1) this.settings.inserts = [];
    //     // this.inserts[index].insertElementParent.appendChild(this.inserts[index].clone);
    //   } else {
    //     // this.inserts[index].clone.remove();
    //     // this.inserts[index].insertElementParent.appendChild(this.inserts[index].insertElement);
    //   }
    // });

    this.settings.inserts.forEach((insert, index) => {
      this.inserts[index] = this.inserts[index] || {};
      this.inserts[index].insertElement = this.inserts[index].insertElement || document.querySelector(insert.selector);
      if (!this.inserts[index]) return;

      this.inserts[index].insertElementParent = this.inserts[index].insertElementParent || this.inserts[index].insertElement.parentElement;

      this.inserts[index].placeToInsert = this.inserts[index].placeToInsert || this.querySelector(`[insert=${insert.insert}]`);
      if (!this.inserts[index].placeToInsert) return;

      if (this.show) {
        // const heightToKeep = this.inserts[index].insertElementParent.offsetHeight;
        // this.inserts[index].insertElementParent.style.minHeight = heightToKeep + 'px';
        this.inserts[index].clone = this.inserts[index].clone || this.inserts[index].insertElement.cloneNode(true);
        // if (!this.inserts[index].clone.classList.includes('clone')) 
        this.inserts[index].clone.classList.add('clone');
        this.inserts[index].placeToInsert.appendChild(this.inserts[index].insertElement);
        this.inserts[index].insertElementParent.appendChild(this.inserts[index].clone);
      } else {
        // this.inserts[index].clone.remove();
        this.inserts[index].insertElementParent.appendChild(this.inserts[index].insertElement);
        this.inserts[index].placeToInsert.appendChild(this.inserts[index].clone);
      }
    });
  }

  // initSizeGuide() {
    // if (this.id !== 'sizeguidePopup') return;

    // const ipCountry = localStorage.getItem('ip_country') || 'all';

    // // Check if it has US images
    // const someUSImg = this.querySelector('img[ip-country="US"]');
    // if (!someUSImg) return;

    // const sizeguideImages = sizeguidePopup.querySelectorAll('img[ip-country]');
    // if (!sizeguideImages) return;

    // sizeguideImages.forEach((image) => {
    //   if (ipCountry === 'US') {
    //     if (image.getAttribute('ip-country') === 'US') {
    //       image.style.display = 'block';
    //     } else {
    //       image.style.display = 'none';
    //     }
    //   } else {
    //     if (image.getAttribute('ip-country') === 'all') {
    //       image.style.display = 'block';
    //     } else {
    //       image.style.display = 'none';
    //     }
    //   }
    // });
  // }

  initViselyRecommendations() {
    if (this.id !== 'CartSide' || !window.Visely || this.classList.contains('cart-top') || this.viselyRecommendationsInited) return;
    if (!window.Visely.RecommendationsApi) return;

    const recommendationsElement = this.querySelector('.cart-upsell');
    if (!recommendationsElement) {
      this.viselyRecommendationsInited = false;
      return;
    }

    window.Visely.RecommendationsApi.show(new Map([["YOU_MAY_ALSO_LIKE_PER_COLLECTION_UPSELL", {}]]));
    console.log('Initialised YOU_MAY_ALSO_LIKE_PER_COLLECTION_UPSELL');

    this.viselyRecommendationsInited = true;
  }

  // initSearch() {
  //   (this.id !== 'search') return;
  // }
}
if (!customElements.get('cos-popup')) customElements.define('cos-popup', CosPopup);

class CosPopupCart extends CosPopup {
  constructor() {
    super();
    this.cartTopListeners = new Listeners();
  }

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener('cos.cart.added', (e) => {
      if (!this.show) this.toggleCart(e);
    });
  }

  destroy() {
    super.destroy();
    this.cartTopListeners.removeAll();
  }

  toggleCart(e) {
    document.dispatchEvent(new CustomEvent('cos.popups.close', {
      detail: { id: this.id }
    }));
    this.extraClassesAdd('cart__top');
    this.hideOnScroll = true;
    this.togglePopup(e);

    const cartSwitcher = this.querySelector('[data-go-to-cart]');
    if (!cartSwitcher) return;
    
    this.cartTopListeners.add(cartSwitcher, 'click', (e) => {
      // if (window.matchMedia("(max-width: 989px)").matches) return;
      
      e.preventDefault();
      this.dispatchEvent(new CustomEvent('cos.popup.cartSwitcher'));
      this.timeOutClose(false);
      this.clearExtraClasses();
      this.cartTopListeners.removeAll();
      this.removeOnScroll();
      // this.initViselyRecommendations();
      // this.updateSlider(true);
    });

    const cartRemove = this.querySelectorAll('[data-cart-remove]');
    cartRemove.forEach(remove => {
      this.cartTopListeners.add(remove, 'click', (e) => {
        this.style.height = this.offsetHeight + 'px';

        document.addEventListener('cart.requestComplete', (e) => {
          setTimeout(() => {
            this.hidePopup(e);
            this.style.height = '';
          }, 600);
        }, {once: true});
      });
    });
  }

}
customElements.define('cos-popup-cart', CosPopupCart);

class CosPopupClose extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const popup = this.closest('cos-popup') || this.closest('.cos-popup');
      if (!popup) return;

      popup.hidePopup(event, true);
    });
  }
}
// check if el is not initialized
if (!customElements.get('cos-popup-close')) customElements.define('cos-popup-close', CosPopupClose);

class CosPopupTrigger extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const popupId = this.getAttribute('popup-id');
      if (!popupId) return;

      const popup = document.querySelector('#' + popupId);
      if (!popup) return;

      popup.togglePopup(event);
    });
  }
}
// check if el is not initialized
if (!customElements.get('cos-popup-trigger')) customElements.define('cos-popup-trigger', CosPopupTrigger);

class CosProductCard extends HTMLElement {
  constructor() {
    super();
    this.listeners = new Listeners();
    this.preloadListeners = new Listeners();
    this.hideListeners = new Listeners();
    this.colorsListeners = new Listeners();
    this.settings = JSON.parse(this.getAttribute('data-settings')) || {}; 
    if (this.settings.inSlider === undefined) this.settings.inSlider = JSON.parse(this.getAttribute('data-in-slider')) || false;
    this.colors = [];
  }

  connectedCallback() {
    this.initQuickAdd();
    this.initSlider();
  }

  disconnectedCallback() {
    this.listeners.removeAll();
    this.timeOutClose(false);
  }

  hideQuickAdd(e) {
    this.hideListeners.removeAll();
    this.colorsListeners.removeAll();
    this.classList.remove('quick-add-active', 'show-options', 'show-colors');
  }

  timeOutClose(runAgain = true) {
    if (this.timeOut) clearTimeout(this.timeOut);
    if (runAgain) this.timeOut = setTimeout(() => this.hideQuickAdd(), 800);
  }

  initQuickAdd() {
    this.querySelectorAll('[trigger-quick-add]').forEach((trigger) => {
      this.listeners.add(trigger, 'click', (e) => {
        e.preventDefault();
        const triggerType = trigger.getAttribute('trigger-quick-add');
        this.showQuickAdd(triggerType);
      });
    });

    this.classList.add('initialized');
  }

  showQuickAdd(triggerType) {
    this.timeOutClose(false);
    this.hideQuickAdd();
    // const firstOption = this.querySelector('.option');
    
    if (triggerType === 'options') {
      // try {
      //   if (firstOption.textContent === 'U') {
      //     firstOption.click();
      //   } else {
      //     this.classList.add('quick-add-active', 'show-options');
      //   }
      // } catch (e) {
      // Bugsnag.notify(e);
      //   console.warn(e);
      // }
      this.classList.add('quick-add-active', 'show-options');
    } else {
      // if (!this.settings.allColorsLoaded) {
      //   this.updateColors();
      // } else {
      // }
      this.addColorListeners();   
    }

    this.hideListeners.add(document, 'keydown', ({key}) => key === "Escape" && this.hideQuickAdd());
    // this.hideListeners.add(document, 'touchstart', (e) => this.onClickOutside(e));
    this.hideListeners.add(window, 'hashchange', () =>  this.hideQuickAdd());
    this.hideListeners.add(document, 'scroll', () => this.timeOutClose());
    // this.hideListeners.add(this, 'mouseover', () => this.timeOutClose(false));
    this.hideListeners.add(this, 'mouseout', () => this.timeOutClose()); 
    this.hideListeners.add(this, 'mouseleave', () => this.timeOutClose()); 
    this.querySelectorAll('.quick-add-wrap').forEach((wrap) => {
      this.hideListeners.add(wrap, 'mouseover', () => this.timeOutClose(false));
      this.hideListeners.add(wrap, 'mouseout', () => this.timeOutClose()); 
      this.hideListeners.add(wrap, 'mouseleave', () => this.timeOutClose()); 
    });
  }

  addColorListeners() {
    this.activeColor = this.querySelector('[data-switch].selected');
    this.classList.add('quick-add-active', 'show-colors'); 

    this.querySelectorAll('[data-switch]').forEach((color, idx) => {
      if (!this.colors[idx]) this.colors[idx] = {
        href: color.href.split('?')[0],
        handle: color.getAttribute('data-switch'),
        bgColor: color.style.backgroundColor
      };
      
      this.colorsListeners.add(color, 'mouseover', () => this.handlePreload(color, idx));
      this.colorsListeners.add(color, 'touchstart', () => this.handlePreload(color, idx));
      this.colorsListeners.add(color, 'click', (e) => {
        e.preventDefault();

        this.clicked = true;
        this.classList.add('loading');
        this.handlePreload(color, idx);
      });
    });

    console.log('this.colors', this.colors);
  }

  async handlePreload(color, idx) {
    this.preloadListeners.remove(color, 'mouseover');
    this.preloadListeners.remove(color, 'touchstart');
    this.colors[idx].response = this.colors[idx].response || await this.getNewPC(idx);

    if (!this.clicked) return;

    this.preparingColor = this.colors[idx].href;

    const newPC = this.colors[idx].response;
    newPC.replace(/keen-loaded|lazy-loaded|lazy-waiting|wk-skip/g, '');
    
    const wrapper = new DOMParser().parseFromString(newPC, 'text/html');

    this.setAttribute('data-product-handle', this.colors[idx].handle);
    this.switchSlider(wrapper);
    this.switchDetails(wrapper);
    this.switchMediaDetails(wrapper);
    this.switchWishlistIcon(wrapper);

    this.listeners.removeAll();
    this.initQuickAdd();

    this.classList.remove('loading');
    this.changeActiveColor(color);

    this.clicked = false;
  }

  switchColors(wrapper) {
    const newColors = wrapper.querySelector('.colors');
    if (!newColors) return;

    const colors = this.querySelector('.colors');
    if (!colors) return;

    colors.replaceWith(newColors);
  }

  switchSlider(wrapper) {
    const newSlider = wrapper.querySelector('.keen-slider');
    if (!newSlider) return;

    const currentSlider = this.querySelector('.keen-slider');
    if (!currentSlider) return;

    newSlider.classList.remove('keen-loaded');
    currentSlider.replaceWith(newSlider);
    window.handleImages(currentSlider);
    this.initSlider();

    // this.timeOutClose();
  }

  switchDetails(wrapper) {
    const newDetails = wrapper.querySelector('.product-card--details');
    if (!newDetails) return;

    const currentDetails = this.querySelector('.product-card--details');
    if (!currentDetails) return;

    currentDetails.replaceWith(newDetails);

    const productTitle = this.querySelector('[data-product-title]');
    if (productTitle) this.productTitle = productTitle.dataset.productTitle;
  }

  switchMediaDetails(wrapper) {
    const newMediaDetails = wrapper.querySelector('.media-box--details');
    if (!newMediaDetails) return;

    const currentMediaDetails = this.querySelector('.media-box--details');
    if (!currentMediaDetails) return;

    currentMediaDetails.replaceWith(newMediaDetails);
  }

  switchWishlistIcon() {
    const wkSkip = this.querySelector('[wk-skip]');
    if (wkSkip) wkSkip.removeAttribute('wk-skip');

    const wishlistIcon = this.querySelector('wishlist-button-collection');
    if (wishlistIcon) wishlistIcon.remove();
  }

  async getNewPC(idx) {    
    const productInPage = document.querySelector(`cos-product-card[data-product-handle="${this.colors[idx].handle}"]`);    
    if (productInPage) {
      this.colors[idx].response = productInPage.outerHTML; // productInPage.settings.initialHTML || productInPage.outerHTML;
    } else {
      const view = this.settings.onlyProductPhotos ? 'only-product-photos' : this.settings.onlyModelPhotos ? 'only-model-photos' : 'card';
      this.colors[idx].response = await fetch(`${this.colors[idx].href}${this.colors[idx].href.includes('?') ? '&' : '?'}view=${view}`).then(response => response.text());
    } 
    
    return this.colors[idx].response;
  }

  changeActiveColor(color) {
    if (this.activeColor) this.activeColor.classList.remove('selected');
    this.activeColor = color;
    this.activeColor.classList.add('selected');
  }

  async initSlider() {
    if (this.settings.inSlider) return;

    const sliderWrap = this.querySelector('.keen-slider:not(.keen-loaded)');
    if (!sliderWrap) return;
    if (sliderWrap.childElementCount < 2) return;

    const productTitle = this.querySelector('[data-product-title]');
    if (productTitle) this.productTitle = productTitle.dataset.productTitle;

    // const { default: KeenSlider } = await import(window.modules['keen-slider']);  
    const settings = JSON.parse(
      sliderWrap.getAttribute('data-slider-settings')
    ) || {
      "loop": true,
      "selector": ".keen-slider__slide",
      "disabled": false,
      // "mode": "free-snap",
      "slides": { 
        "origin": "auto",
        "perView": 1,    
        "spacing": 0
      },
      "renderMode": "custom"
    };

    KeenSlider(sliderWrap, settings, [(slider) => {
      slider.on('created', () => {
        slider.container.classList.add('keen-loaded');
        // slider.container.classList.remove('keen-fade');
        (slider.options.disabled) ? slider.container.classList.add('keen-disabled') : slider.container.classList.remove('keen-disabled');
      });
      slider.on('optionsChanged', () => {
        console.log('optionsChanged');
        (slider.options.disabled) ? slider.container.classList.add('keen-disabled') : slider.container.classList.remove('keen-disabled');
      });
      slider.on('dragStarted', () => {
        this.timeOutClose();
      });
      slider.on('detailsChanged', () => {
        slider.slides.forEach((element, idx) => {
          // element.style.display = 'block';
          element.style.opacity = slider.track.details.slides[idx].portion;
          element.style.zIndex = slider.track.details.slides[idx].portion;
        })
      });
      slider.on('slideChanged', () => {
        if (slider.options.disabled) return;
        slider.container.classList.add('keen-active');
        this.triggerGtag(slider);
      });
    }, (slider) => {
      const wrapper = this.querySelector('.media-box');
      let arrowLeft; 
      let arrowRight; 

      function markup(remove) {
        arrowMarkup(remove);
      }

      function arrowMarkup(remove) {
        if (remove) {
          removeElement(arrowLeft);
          removeElement(arrowRight);
          return;
        }
        arrowLeft = createDiv('btn slick-arrow slick-prev');
        arrowRight = createDiv('btn slick-arrow slick-next');

        const slidesToMove = 1;
        arrowLeft.addEventListener('click', () => slider.moveToIdx(slider.track.details.rel - slidesToMove));
        arrowRight.addEventListener('click', () => slider.moveToIdx(slider.track.details.rel + slidesToMove));

        wrapper.appendChild(arrowLeft);
        wrapper.appendChild(arrowRight);
      }

      slider.on('created', () => {
        if (slider.options.disabled) return;
        markup();
      });  
      slider.on('optionsChanged', () => {
        markup(true);
        if (slider.options.disabled) return;
        markup();
      });
      // slider.on('slideChanged', () => {
      //   if (slider.options.disabled) return;
      //   updateClasses();
      // });
      slider.on('destroyed', () => {
        markup(true);
      });
    }]);
  }

  triggerGtag(slider) {
    const options = { 
      "image_position": slider.track.details.rel, // 2 for the second image
      "category": "product_slider", 
      "product_name": this.productTitle, // or product ID if available
      "page_location": window.location.href // Capture the page URL or product 
    }

    if (typeof gtag !== 'function') return;
    console.log(options)
    gtag('event', 'pcard_photo_swipe', options);
  }

  // async updateColors() {
  //   this.firstColor = this.querySelector('[data-switch]');
  //   this.activeColor = this.querySelector('[data-switch].selected');
  //   if (!this.firstColor  || !this.activeColor) return;

  //   this.colors[0] = {
  //     href: this.firstColor.href.split('?')[0]
  //   };
    
  //   const newPC = await this.getNewPC(0);
  //   const wrapper = document.createElement('div');
  //   wrapper.innerHTML = newPC;

  //   this.switchColors(wrapper);
  //   this.switchDetails(wrapper);
    
  //   this.settings.allColorsLoaded = true;
  //   this.listeners.removeAll();
  //   this.initQuickAdd();

  //   this.showQuickAdd('colors');
  // }
}
customElements.define('cos-product-card', CosProductCard);

class CosSlider extends HTMLElement {
  constructor() {
    super();
    this.listeners = new Listeners();
    this.keenLoaded = false;
    this.settings = JSON.parse(this.getAttribute('data-slider-settings')) || {};
    this.mouseOver = false;
  }

  connectedCallback() {    
    // if (this.settings.delayedInit) {
    //   // const cosPopup = this.closest('cos-popup');
    //   // if (!cosPopup) return;

    //   // cosPopup.addEventListener('cos.popup.isOpened', this.initSlider(), { once: true });

    //   if (window.liquidAjaxCart?.init) {
    //     // if Liquid Ajax Cart is already initialized
    //     this.initSlider();
    //   } else {
    //     // wait for Liquid Ajax Cart to be initialized
    //     document.addEventListener("liquid-ajax-cart:init", this.initSlider());
    //   }

    //   return;
    // }

    this.initSlider();
    this.resizeObserverInit();
    // addEventListener('DOMContentLoaded', async () => {
      // setTimeout(this.initSlider(), 2000)
    // });
  }

  disconnectedCallback() {
    this.listeners.removeAll();
  }

  initSlider() {    
    if (this.getBoundingClientRect().width < 1) return;
    // console.log('this.keenLoaded', this.keenLoaded)
    // console.log('all', this.keenLoaded || this.childElementCount < 2 || (preventIfHidden && !this.checkVisibility()))

    console.log('this.getBoundingClientRect()::', this.getBoundingClientRect())
    
    // if (this.keenLoaded || this.childElementCount < 2 || (preventIfHidden && !this.checkVisibility())) return;
    if (this.keenLoaded || this.childElementCount < 2) return;
    this.dynamicParent = this.closest('[cos-slider-position]');

    this.updateInitial();
    const controls = this.settings.controls ? this.settings.controls === 'dots' ? sliderDots : this.settings.controls === 'upsell' ? upsellArrow : sliderArrows : () => {};

    KeenSlider(this, this.settings, [(slider) => {
      this.slider = slider;

      slider.on('created', () => {
        this.keenLoaded = true;
        
        this.classList.add('keen-loaded');
        this.handleSliderState(slider);

        if (this.settings.autoplay_speed) this.nextTimeout();
      });

      slider.on('optionsChanged', () => {
        this.handleSliderState(slider);
      });

      if (this.dynamicParent) slider.on('slideChanged', () => {
        this.dynamicParent.setAttribute('cos-slider-position', slider.track.details.rel);
      });

      if (this.settings.mode === 'fade') {
        slider.on('detailsChanged', (s) => {
          s.slides.forEach((element, idx) => {
            element.style.opacity = s.track.details.slides[idx].portion;
            element.style.zIndex = s.track.details.slides[idx].portion;
          });
        });
      }
      
      slider.on('slideChanged', () => {
        slider.container.classList.add('keen-active');
      });
        
      if (this.settings.autoplay_speed) {
        slider.on('dragStarted', () => this.clearNextTimeout());
        slider.on('animationEnded', () => this.nextTimeout());
        slider.on('updated', () => this.nextTimeout());
      }
    }, controls]);
  }

  updateSlider() {
    if (!this.keenLoaded || !this.slider) return this.initSlider();
    
    // console.log('updateSlider::', this.slider, this.slider.size)
    // this.updateInitial();
    this.slider.update();
  }

  updateInitial() {
    if (!this.dynamicParent) return;

    this.settings.initial = Number(this.dynamicParent.getAttribute('cos-slider-position')) || 1;
  }

  resizeObserverInit() {
    const resizeObserver = new ResizeObserver((entries) => {
      this.updateSlider();
    });
    
    resizeObserver.observe(this);
  }

  handleSliderState(slider) {
    if (slider.options.disabled) {
      this.classList.add('keen-disabled');
      this.classList.remove('keen-loaded');
    } else {
      this.classList.remove('keen-disabled');
      this.classList.add('keen-loaded');
    }
  }

  clearNextTimeout() {
    if (!this.timeout) return;

    clearTimeout(this.timeout);
  }

  nextTimeout(slider) {
    if (this.timeout) clearTimeout(this.timeout);
    if (this.mouseOver) return;
    this.timeout = setTimeout(() => {
      this.slider.next();
    }, this.settings.autoplay_speed);
  }
}
customElements.define('cos-slider', CosSlider);

class CosTabs extends HTMLElement {
  connectedCallback() {
    this.listeners = new Listeners();
    this.tabs = this.querySelectorAll('cos-tab');
    this.variantTabs = this.querySelectorAll('[data-variant-id]');

    // add custom event to listen for tab change
    this.listeners.add(window, 'variant.change', (event) => {
      // this.changeTab(event.detail.index);
      this.changeTabByVariantId(event.detail.variantId);
    });
  }

  disconnectedCallback() {
    this.listeners.removeAll();
  }

  changeTab(index) {
    this.tabs.forEach((tab, i) => {
      if (i === index) {
        this.showTab(tab);
      } else {
        this.hideTab(tab);
      }
    });
  }

  changeTabByVariantId(variantId) {
    this.variantTabs.forEach((tab) => {
      if (tab.dataset.variantId === variantId?.toString()) {
        this.showTab(tab);
      } else {
        this.hideTab(tab);
      }
    });
  }

  showTab(tab) {
    tab.inert = false;
    
    // const cosSlider = tab.querySelector('cos-slider');
    // if (!cosSlider) return;

    // cosSlider.updateSlider();
  }

  hideTab(tab) {
    tab.inert = true;
  }
}
if (!customElements.get('cos-tabs'))  customElements.define('cos-tabs', CosTabs);

class CosTabsControls extends HTMLElement {
  connectedCallback() {
    this.listeners = new Listeners();
    this.controls = this.querySelectorAll('button');
    this.tabs = document.querySelectorAll(`[data-id=${this.dataset.controls}]`);

    this.controls.forEach((control, index) => {
      this.listeners.add(control, 'click', () => {
        this.changeTab(control, index);
      });
    });
  }

  disconnectedCallback() {
    this.listeners.removeAll();
  }

  changeTab(control, index) {
    this.resetActive();
    this.tabs.forEach((tab) => {
      tab.changeTab(index);
    });
    control.classList.add('active');
  }

  resetActive() {
    this.controls.forEach((control) => {
      control.classList.remove('active');
    });
  }
}
if (!customElements.get('cos-tabs-controls'))  customElements.define('cos-tabs-controls', CosTabsControls);

// (function () {
//   addEventListener('DOMContentLoaded', async () => {
//     const fetchResponse = await fetch('/collections/knits-women?view=naked-layout').then(response => response.text());
//     const wrapper = document.createElement('div');
//     wrapper.innerHTML = fetchResponse;
//     const collectionGrid = wrapper.querySelector('[collection-grid]');
//     const main = document.querySelector('main');
//     if (!collectionGrid || !main) return;

//     main.appendChild(collectionGrid);
//   });
// })();

// (function () {
//   'use strict';

//   addEventListener('DOMContentLoaded', () => {
//     // #cat-faq-accordion
//     // #product-accordion
//     // const accordions = document.querySelectorAll('[aws-accordion]');
//     const generalAccordions = Array.from(document.querySelectorAll('[aws-accordion]'));
//     if (generalAccordions.length) {
//       import(window.modules.accordion)
//         .then(({ default: Accordion }) => {
//           new Accordion(generalAccordions, {});
//         })
//         .catch((e) => {
//           Bugsnag.notify(e);
//           console.warn(e);
//         });
//     }
//   });
// })();

(function () {
  'use strict';

  document.querySelectorAll('details').forEach((details) => {
    const summary = details.querySelector('summary');
    if (!summary) return;

    summary.addEventListener('click', (e) => {
      e.preventDefault();
      import(window.modules.details)
      .then(({ default: Details }) => {
        const newDetails = new Details(details);
        newDetails.open();
      })
      .catch((e) => {
        details.open = true;
      });

      const settings = JSON.parse(details.getAttribute('data-settings')) || {};
      if (!settings.load_modules) return;

      settings.load_modules.forEach((module) => {
        import(module).then(() => {
          console.log('Loaded ' + module);
          document.dispatchEvent(new CustomEvent('details.module.loaded', { detail: 
            { module } 
          }));
        });
      });
    }, { once: true });
  });
})();

(function () {
  async function initCountryDependentSliders() {
  
    const keenSettings = {
      loop: true, 
      // defaultAnimation: {
      //   duration: 3000,
      // },  
      slides: { 
        perView: 1,
      },
      detailsChanged: (s) => {
        s.slides.forEach((element, idx) => {
          element.style.display = 'block';
          element.style.opacity = s.track.details.slides[idx].portion;
          element.style.zIndex = s.track.details.slides[idx].portion;
        });
      },
      created: (slider) => {
        slider.container.classList.add("keen-loaded");
      },
      slideChanged: (slider) => {
        slider.container.classList.add('keen-active');
      },
      renderMode: "custom",
    };

    // Init blue banner slider 
    const messageSlider = document.querySelector('#message_slider');
    if (messageSlider) {
      const messageSlides = messageSlider.querySelectorAll('.keen-slider__slide');
      if (messageSlides.length > 1) KeenSlider(messageSlider, keenSettings, [sliderAutoPlay]);
    }
  
    // Init reviews slider 
    const reviewsSlider = document.querySelector('#reviews-slider');
    if (reviewsSlider) {
      const reviewsSliderSettings = keenSettings;
      reviewsSliderSettings.autoplay = 3000;
      const reviewsSlides = reviewsSlider.querySelectorAll('.keen-slider__slide');
      if (reviewsSlides.length > 1) KeenSlider(reviewsSlider, reviewsSliderSettings, [sliderAutoPlay, sliderArrows]);
    }
  }

  addEventListener('DOMContentLoaded', () => {
    initCountryDependentSliders();
  });
})();

(function () {
  // #lookbooks-slider-nav
  // #cat-slider-nav
  // #products-slider

  document.addEventListener('DOMContentLoaded', async () => {
    const sliders = document.querySelectorAll('[slider-nav]');
    if (!sliders.length) return;

    sliders.forEach((slider) => {
      const settings = {
        loop: true,
        slides: { 
          origin: "center", 
          perView: "auto",    
          spacing: 20            
        },
        breakpoints: {
          "(min-width: 950px)": {
            mode: "free-snap",
            slides: { 
              origin: "auto", 
              perView: (slider.getAttribute('keen-max-width')) ? 3 : "auto",
              spacing: 20            
            }
          }
        }
      };
      settings.created = (slider) => {
        slider.container.classList.add('keen-loaded');
      };

      KeenSlider(slider, settings, [sliderArrows]);
    });
  });
})();

(function () {
  let backToTopInited = false;
  const backToTop = document.querySelector('[back-to-top]');
  if (!backToTop) return;

  function initBackToTop() {
    const grid = document.querySelector('[collection-grid]') || document.querySelector('#MainContent');
    if (!grid) return;

    const triggerPresent = grid.querySelector('[back-to-top-trigger]');
    
    if (backToTopInited && triggerPresent) return;
    if (grid.getBoundingClientRect().height === 0) return; 

    backToTopInited = true;

    const trigger = document.createElement('span');
    trigger.classList.add('back-to-top-trigger');
    trigger.setAttribute('back-to-top-trigger', '');
    grid.appendChild(trigger);
    
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && grid.getBoundingClientRect().height > 4000) {  
        backToTop.classList.add('is-visible');
      } else {
        backToTop.classList.remove('is-visible');
      }
    }, {
      threshold: 1
    });
    observer.observe(trigger);

    backToTop.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });
  }

  initBackToTop();
  document.addEventListener('visely.recommendation.rendered', () => {
    initBackToTop();
  });
  document.addEventListener('search.rendered', () => {
    initBackToTop();
  });
})();

(function () {
  const header = document.querySelector('.site-header');
  const body = document.querySelector('body');
  const blueNav = document.querySelector('.announcement-bar');
  if (!header || !blueNav) return;

  const observer = new window.IntersectionObserver((entries) => {
    header.classList.toggle('is-sticky', entries[0].intersectionRatio < 1);
    body.classList.toggle('sticky-header', entries[0].intersectionRatio < 1);
  }, {
    // root: null,
    threshold: 1.0,
    rootMargin: `${blueNav.offsetHeight}px`
  });

  observer.observe(blueNav);
})();

// (function () {
//   const intersectionObserver = new IntersectionObserver((entries) => {
//     entries.forEach((entry) => {
//       if (entry.intersectionRatio > 0 && !entry.target.classList.contains('initialised')) {
//         if (!window.Visely) return;

//         const sliderAttr = entry.target.getAttribute('visely-slider');
//         if (!sliderAttr || sliderAttr === '') return;

//         if (window.Visely.RecommendationsApi) window.Visely.RecommendationsApi.show(new Map([[sliderAttr, {}]]));

//         console.log('Initialised ' + sliderAttr);
//         entry.target.classList.add('initialised');
//       }
//     });
//   }, {
//     rootMargin: '100% 0px',
//     threshold: 0,
//   });

//   addEventListener('visely.app.initialized', () => {
//     console.log('visely.app.initialized');
//     const viselySliders = document.querySelectorAll('[visely-slider]') || [];

//     viselySliders.forEach((viselySlider) => {
//       intersectionObserver.observe(viselySlider);
//     });
//   });
// })();

// (function () {
//   async function initViselyRecommendationsSlider(container) {
//     const sliderWrap = container.querySelector('.visely-recommendations-container');
//     if (!sliderWrap) return;
//     if (sliderWrap.childElementCount < 3) return;
//     if (container.classList.contains('keen-loaded')) return;

//     const elWithSettings = container.closest('[data-slider-settings]') || container;
//     const settings = JSON.parse(
//       elWithSettings.getAttribute('data-slider-settings')
//     ) || {
//       "loop": true,
//       "selector": ".slide",
//       "mode": "free-snap",
//       "slides": { 
//         "origin": "auto", 
//         "perView": 2,    
//         "spacing": 10            
//       },
//       "breakpoints": {
//         "(min-width: 750px)": {
//           "mode": "free-snap",
//           "slides": { 
//             "origin": "auto", 
//             "perView": 3,
//             "spacing": 20            
//           }
//         }
//       },
//       "controls": "arrows"
//     };
//     const controls = settings.controls ? settings.controls === 'upsell' ? upsellArrow : sliderArrows : () => {};

//     KeenSlider(sliderWrap, settings, [(slider) => {
//       slider.on('created', () => {
//         slider.container.classList.add('keen-loaded');
//         slider.container.classList.remove('keen-fade');
//         (slider.options.disabled) ? slider.container.classList.add('keen-disabled') : slider.container.classList.remove('keen-disabled');
//       });
//       slider.on('optionsChanged', () => {
//         console.log('optionsChanged');
//         (slider.options.disabled) ? slider.container.classList.add('keen-disabled') : slider.container.classList.remove('keen-disabled');
//       });
//     }, controls]);
//   }

//   // Init Visely recommendations slider
//   document.addEventListener('visely.recommendation.rendered', (event) => {
//     console.log('visely.recommendation.rendered');

//     const container = event.detail.element;
//     if (!container) return;

//     initViselyRecommendationsSlider(container);
//   });
// })();

(function () {
  const intersectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0 && !entry.target.classList.contains('initialised')) {
        
        const triggerAttr = entry.target.getAttribute('delayed-trigger');
        if (!triggerAttr || triggerAttr === '') return;

        const url = (triggerAttr.includes('//')) ? triggerAttr : (window.delayedUrls) ? window.delayedUrls[triggerAttr] : null;
        if (!url || url === '') return;
        
        if (url.includes('.min.css')) {
          loadCSS(url, () => {
            console.log('Loaded ' + url);
          });
        } else {
          loadScript(url, () => {
            console.log('Loaded ' + url);
          });
        }

        console.log('Loading... ' + url);
        entry.target.classList.add('initialised');
        intersectionObserver.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '100% 0px',
    threshold: 0
  });


  addEventListener('DOMContentLoaded', () => {
    if (window.Shopify.designMode) return;

    document.querySelectorAll('[delayed-trigger]').forEach((trigger) => {
      intersectionObserver.observe(trigger);
    });
  });
})();

// (function () {
//   // Cookie consent
//   const cookieConsent = document.querySelector('#cookie-banner');
//   if (!cookieConsent || localStorage.getItem('CookieSConsentTWOTHIRDS') === 'shown') return;
  
//   setTimeout(() => {
//     // TODO: clean up
//     cookieConsent.style.display = 'block';
//     cookieConsent.inert = false;
//     localStorage.setItem('CookieSConsentTWOTHIRDS', 'shown');
//   }, 2000);

//   cookieConsent.addEventListener('click', (e) => {
//     // TODO: clean up
//     cookieConsent.style.display = 'none';
//     cookieConsent.inert = true;
//   });
// })();

(function (window, document) {
  'use strict';

  window.addEventListener('load', function() {
    document.querySelectorAll('.overflow-auto:not(.buttons)').forEach(el => {
      el.scrollWidth > el.offsetWidth && el.classList.add('overflowed');
    });
  });
})(window, document);

(function (window, document) {
  'use strict';

  function handleSmile() {
    window.SmileUI.ready().then(() => {
      // possible param: smileUiInstance
      window.SmileUI.openPanel();
    }).catch(e => {
      // An error has occurred will intializing SmileUI      
      Bugsnag.notify(e);
      console.warn(e);
    });
  }

  function handleTarget(targetHash) {
    // console.log('handleTarget', targetHash);
    const target = targetHash || window.location.hash;
    if (!target || target === '') return;
    // console.log('handleTarget', target);
    // window.location.hash = '';

    // smile-home
    if (target === 'smile-home' || target === '#smile-home') {
      if (window.SmileUI) {
        handleSmile();
      } else {
        document.addEventListener('smile-ui-loaded', () => {
          handleSmile();
        });
      }

      return;
    };
  
    const onSortScrollTo = document.querySelector(target.includes('#') ? target : '#' + target);
    if (!onSortScrollTo) return;

    onSortGoTo(onSortScrollTo);
  
    // remove hash from url
    window.history.replaceState({}, document.title, window.location.pathname);
  }

  addEventListener('DOMContentLoaded', () => {
    handleTarget();

    const allRelativeLinks = document.querySelectorAll('[is-anchor]');
    allRelativeLinks.forEach((link) => {
      link.addEventListener('click', (e) => { 
        // Check if the page has the same relative link
        const origin = window.location.origin;
        const href = link.getAttribute('href').replace(origin, '');
        const hrefPath = href.split('#')[0];
        
        if (hrefPath === '' || hrefPath === window.location.pathname) {
          e.preventDefault();

          const target = href.split('#')[1];
          handleTarget(target);
        }
      });
    });

    // data-goto links
    const allGoToLinks = document.querySelectorAll('[data-goto]');
    allGoToLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        
        let target = link.getAttribute('data-goto');
        if (target === 'nextSection') {
          const nextSection = link.closest('.shopify-section').nextElementSibling;
          if (nextSection) {
            if (nextSection.classList.contains('shopify-section')) target = nextSection.id;
          }
        }

        handleTarget(target);
      });
    });
  });

  addEventListener('hashchange', (e) => {
    handleTarget();
  });
})(window, document);

// (function () {
//   if (window.SmileUI) {
//     handleSmile();
//   } else {
//     document.addEventListener('smile-ui-loaded', () => {
//       handleSmile();
//     });
//   }

//   function handleSmile() {
//     window.SmileUI.ready().then(() => {
//       // possible param: smileUiInstance
//       // get #smile-ui-container
//       const smileUiContainer = document.querySelector('#smile-ui-container');
//       if (!smileUiContainer) return;
  
//       smileUiContainer.style.zIndex = 9999;
//     }).catch(e => {
//       Bugsnag.notify(e);
//       console.warn(e);
//       // An error has occurred will intializing SmileUI
//     });
//   }
// })();

(function() {
  addEventListener('DOMContentLoaded', async () => {
    // Team param preparations
    const urlParams = new URLSearchParams(window.location.search);
    const teamParam = urlParams.get('team');
    
    if (teamParam !== null) {
      sessionStorage.setItem('team', 'default');
    }
    
    if (sessionStorage.getItem('team') === null) return;
    
    // Remove team param from URL
    const url = new URL(window.location.href);
    url.searchParams.delete('team');
    window.history.replaceState({}, document.title, url.href);
    
    // loadScript(window.modules['team-js']);
    await import(window.modules['team-js']);
  });
})();

(function() {
  window.addEventListener('DOMContentLoaded', () => {
    window.fonts.forEach(({ selector, family, src, style, weight }) => {
      const font = new FontFace(family, `url(${src})`, {
        style,
        weight
      });

      const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            font.load().then(() => {
              document.fonts.add(font);
            });

            entry.target.classList.add('font-loaded');
            intersectionObserver.unobserve(entry.target);
          }
        });
      }, {
        rootMargin: '100% 0px',
        threshold: 0
      });

      document.querySelectorAll(selector).forEach((trigger) => {
        intersectionObserver.observe(trigger);
      });
    });
  })
})();
    
    // (function () {
    //   const refcandy = document.querySelector('#refcandy-poprocks');
    //   if (!refcandy) return;

    //   const iframe = refcandy.querySelector('iframe');
    //   if (!iframe) return;

    //   iframe.addEventListener('load', () => {
    //     const button = iframe.contentWindow.document.querySelector('#button');
    //     if (!button) return;

    //     button.addEventListener('click', () => {
    //       console.log('RefCandy button clicked');
    //     });
    //   });
    // })();

    // (function () {
    //   // Modifying the style for Klarna payment method
    //   const klarnaPlacement = document.querySelector('klarna-placement');
    //   if (!klarnaPlacement) return;

    //   const klarnaStyle = document.createElement( 'style' );
    //   klarnaStyle.innerHTML = '.container { font-size: 10px; }';

    //   setTimeout(klarnaPlacement.shadowRoot.appendChild(klarnaStyle), 1000); 
    // })();

    // (function () {
    //   const stickyEls = document.querySelectorAll('.sticky-js');

    //   const observer = new window.IntersectionObserver((entries) => {
    //     entries.forEach((entry) => {
    //       if(entry.isIntersecting) {
    //         entry.target.classList.remove('is-sticky'); 
    //       } else {
    //         entry.target.classList.add('is-sticky');
    //       }
    //     });
    //   }, {
    //     // root: null,
    //     threshold: 1.0
    //   });

    //   stickyEls.forEach((stickyEl) => {
    //     observer.observe(stickyEl);
    //   });
    // })();

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    // this.mql = window.matchMedia('(min-width: 750px)');
    // this.header = document.querySelector('.header-wrapper');
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      // button: this.querySelector('button.localization-form__select'),
      // panel: this.querySelector('.disclosure__list-wrapper'),
      // search: this.querySelector('input[name="country_filter"]'),
      closeButton: this.querySelector('.country-selector__close-button'),
      // resetButton: this.querySelector('.country-filter__reset-button'),
      // searchIcon: this.querySelector('.country-filter__search-icon'),
      // liveRegion: this.querySelector('#sr-country-search-results'),
    };
    // this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    // this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
    // this.addEventListener('focusout', this.closeSelector.bind(this));
    // this.elements.button.addEventListener('click', this.openSelector.bind(this));

    // if (this.elements.search) {
    //   this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
    //   this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
    //   this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
    //   this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
    // }
    // if (this.elements.closeButton) {
    //   this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
    // }
    // if (this.elements.resetButton) {
    //   this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
    //   this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
    // }

    this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  // hidePanel() {
  //   this.elements.button.setAttribute('aria-expanded', 'false');
  //   this.elements.panel.setAttribute('hidden', true);
  //   if (this.elements.search) {
  //     this.elements.search.value = '';
  //     this.filterCountries();
  //     this.elements.search.setAttribute('aria-activedescendant', '');
  //   }
  //   document.body.classList.remove('overflow-hidden-mobile');
  //   document.querySelector('.menu-drawer').classList.remove('country-selector-open');
  //   this.header.preventHide = false;
  // }

  // onContainerKeyDown(event) {
  //   const focusableItems = Array.from(this.querySelectorAll('a')).filter(
  //     (item) => !item.parentElement.classList.contains('hidden')
  //   );
  //   let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
  //   let itemToFocus;

  //   switch (event.code.toUpperCase()) {
  //     case 'ARROWUP':
  //       event.preventDefault();
  //       itemToFocus =
  //         focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
  //       itemToFocus.focus();
  //       break;
  //     case 'ARROWDOWN':
  //       event.preventDefault();
  //       itemToFocus =
  //         focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
  //       itemToFocus.focus();
  //       break;
  //   }

  //   if (!this.elements.search) return;

  //   setTimeout(() => {
  //     focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
  //     if (focusedItemIndex > -1) {
  //       this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
  //     } else {
  //       this.elements.search.setAttribute('aria-activedescendant', '');
  //     }
  //   });
  // }

  // onContainerKeyUp(event) {
  //   event.preventDefault();

  //   switch (event.code.toUpperCase()) {
  //     case 'ESCAPE':
  //       if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
  //       this.hidePanel();
  //       event.stopPropagation();
  //       this.elements.button.focus();
  //       break;
  //     case 'SPACE':
  //       if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
  //       this.openSelector();
  //       break;
  //   }
  // }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  // openSelector() {
  //   this.elements.button.focus();
  //   this.elements.panel.toggleAttribute('hidden');
  //   this.elements.button.setAttribute(
  //     'aria-expanded',
  //     (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
  //   );
  //   if (!document.body.classList.contains('overflow-hidden-tablet')) {
  //     document.body.classList.add('overflow-hidden-mobile');
  //   }
  //   if (this.elements.search && this.mql.matches) {
  //     this.elements.search.focus();
  //   }
  //   if (this.hasAttribute('data-prevent-hide')) {
  //     this.header.preventHide = true;
  //   }
  //   document.querySelector('.menu-drawer').classList.add('country-selector-open');
  // }

  // closeSelector(event) {
  //   if (
  //     event.target.classList.contains('country-selector__overlay') ||
  //     !this.contains(event.target) ||
  //     !this.contains(event.relatedTarget)
  //   ) {
  //     this.hidePanel();
  //   }
  // }

  // normalizeString(str) {
  //   return str
  //     .normalize('NFD')
  //     .replace(/\p{Diacritic}/gu, '')
  //     .toLowerCase();
  // }

  // filterCountries() {
  //   const searchValue = this.normalizeString(this.elements.search.value);
  //   const popularCountries = this.querySelector('.popular-countries');
  //   const allCountries = this.querySelectorAll('a');
  //   let visibleCountries = allCountries.length;

  //   this.elements.resetButton.classList.toggle('hidden', !searchValue);

  //   if (popularCountries) {
  //     popularCountries.classList.toggle('hidden', searchValue);
  //   }

  //   allCountries.forEach((item) => {
  //     const countryName = this.normalizeString(item.querySelector('.country').textContent);
  //     if (countryName.indexOf(searchValue) > -1) {
  //       item.parentElement.classList.remove('hidden');
  //       visibleCountries++;
  //     } else {
  //       item.parentElement.classList.add('hidden');
  //       visibleCountries--;
  //     }
  //   });

  //   if (this.elements.liveRegion) {
  //     this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
  //       '[count]',
  //       visibleCountries
  //     );
  //   }

  //   this.querySelector('.country-selector').scrollTop = 0;
  //   this.querySelector('.country-selector__list').scrollTop = 0;
  // }

  // resetFilter(event) {
  //   event.stopPropagation();
  //   this.elements.search.value = '';
  //   this.filterCountries();
  //   this.elements.search.focus();
  // }

  // onSearchFocus() {
  //   this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
  // }

  // onSearchBlur() {
  //   if (!this.elements.search.value) {
  //     this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
  //   }
  // }

  // onSearchKeyDown(event) {
  //   if (event.code.toUpperCase() === 'ENTER') {
  //     event.preventDefault();
  //   }
  // }
}

if (!customElements.get('localization-form')) customElements.define('localization-form', LocalizationForm);

class CosCartDonation extends HTMLElement {
  connectedCallback() {
    this.listeners = new Listeners();
    this.cosAddToCart = this.querySelector('cos-add-to-cart');
    if (!this.cosAddToCart) return;

    this.swatches = this.querySelectorAll('.single-option-selector');
    this.swatches.forEach((option) => {
      this.listeners.add(option, 'change', () => {
        this.onVariantChange(option);
      });
    });
  }

  disconnectedCallback() {
    this.listeners.removeAll();
  }

  onVariantChange(option) {
    // this.updateSwatches(option);
    this.cosAddToCart.updateAddToCart(option);
  }
}
// check if the element is already registered
if (!customElements.get('cos-cart-donation')) customElements.define('cos-cart-donation', CosCartDonation);

// create a custom html element called cos-add-to-cart
class CosAddToCart extends HTMLElement {
  connectedCallback() {
    this.listeners = new Listeners();
    this.addToCartButton = this.querySelector('button');
    if (!this.addToCartButton) return;    

    this.addToCartText = this.addToCartButton.querySelector('.text-correct') || this.addToCartButton;

    this.listeners.add(document, 'cos.cart.adding', () => {
      this.handleButtonLoadingState(true);
    });
    this.listeners.add(document, 'cos.cart.added', () => {
      this.handleButtonLoadingState(false);
    });

    this.listeners.add(this.addToCartButton, 'click', (e) => {
      this.handleAddToCart(e);
    });
  }

  disconnectedCallback() {
    this.listeners.removeAll();
  }

  handleAddToCart(e) {
    e.preventDefault();

    const id = this.addToCartButton.getAttribute('data-add-id');
    const status = this.addToCartButton.getAttribute('data-add-status');
    const dispatch = this.addToCartButton.getAttribute('data-add-dispatch');

    const cosProductSingle = document.querySelector('cos-product-single');
    if (cosProductSingle) {
      if (cosProductSingle.sizeNotSelected) {
        cosProductSingle.sizeNotSelected = false;
        return cosProductSingle.onSizeTriggerClick(e);
      }
    }
    window.QuickAdd(id, status, dispatch);
  }

  handleButtonLoadingState(isLoading) {
    if (isLoading) {
      this.addToCartButton.setAttribute('aria-disabled', true);
      // this.addToCartButton.setAttribute('disabled', true);
      // this.addToCartButton.textContent = '';
      // this.addToCartButton.insertAdjacentHTML('beforeend', '<span class="loader"></span>');
    } else {
      this.addToCartButton.removeAttribute('aria-disabled');
      // this.addToCartButton.removeAttribute('disabled');
      // this.addToCartButton.textContent = window.theme.strings.addToCart;
      // this.addToCartButton.querySelector('.loader').remove();
    }
  }

  updateAddToCart(option) {
    if (!option) return; 
    if (this.variantId === option.dataset.variantId) return;

    this.variantId = option.dataset.variantId;
    // this.updateSizeTrigger(option);
    this.addToCartButton.setAttribute('data-add-id', this.variantId);

    if (option.dataset.available === 'true') {
      this.enableAddToCart();
    } else {
      this.disableAddToCart();
    }
  }

  enableAddToCart() {
    this.addToCartButton.removeAttribute('disabled');
    this.addToCartButton.removeAttribute('aria-disabled');
    this.addToCartButton.setAttribute('aria-label', window.theme.strings.donationCta);
    this.addToCartText.textContent = window.theme.strings.donationCta;
    // this.addToCartButton.textContent = window.theme.strings.donationCta;
  }

  disableAddToCart() {
    this.addToCartButton.setAttribute('disabled', 'disabled');
    this.addToCartButton.setAttribute('aria-disabled', true);   
    this.addToCartButton.setAttribute('aria-label', window.theme.strings.soldOut);
    this.addToCartText.textContent = window.theme.strings.soldOut;
    // this.addToCartButton.textContent = window.theme.strings.soldOut;
  }
}
// define element
if (!customElements.get('cos-add-to-cart')) customElements.define('cos-add-to-cart', CosAddToCart);